<div class="single-service-render">
  <div class="service-content">
    <!-- Loading State -->
    <div *ngIf="loadingState" class="service-loading">
      <div class="spinner-border text-primary">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-2">{{ 'Loading service form...' | translate }}</p>
    </div>

    <!-- Error State -->
    <div *ngIf="errorState" class="service-error">
      <div class="alert alert-danger">
        <i class="bi bi-exclamation-triangle-fill me-2"></i>
        <span>{{ errorMessage | translate }}</span>
      </div>
    </div>

    <!-- Loaded Form -->
    <div *ngIf="!loadingState && !errorState" class="service-form-container">
      <div *ngIf="journeyFeedbacksForService.length" class="journey-feedbacks">
        <irembogov-officer-comment
          *ngFor="
            let feedback of journeyFeedbacksForService;
            trackBy: trackJourneyFeedback
          "
          [label]="'Officer Feedback' | translate"
          [comment]="feedback.comment || ''">
        </irembogov-officer-comment>
      </div>
      <formly-form
        [form]="serviceForm"
        [fields]="translatedServiceLayout"
        [model]="serviceModel"
        [options]="serviceOptions">
      </formly-form>
    </div>
  </div>
</div>
